import { CARTEIRAS_LIST, CARTEIRAS_FAV, CARTEIRAS_DELETE, CARTEIRAS_CREATE, CARTEIRAS_READ, CARTEIRAS_PL_ADD, CARTEIRAS_PL_LIST, CARTEIRAS_PL_REMOVE, CARTEIRAS_PL_MODIFY } from "../const/servicesURI";
import requestService from "./requestService";
import utils from "../utils";
export const create = (pData, pResolve, pReject, pFinally) => {
  // if (cancel.create) {
  //   cancel.create.cancel();
  // }

  //cancel.create = httpRequests.cancelToken();

  const xProps = {
    data: pData,
    method: "post"
    //cancelToken: cancel.create.token,
  };
  return requestService(xProps, CARTEIRAS_CREATE, 3).then(rRes => {
    return pResolve && pResolve(rRes);
  }).catch(rErr => {
    utils.request.tracer(rErr, "Error Service Carteiras Create");
    return pReject && pReject(rErr);
  }).finally(() => {
    pFinally && pFinally();
  });
};
export const list = (pProps, pResolve, pReject, pFinally) => {
  // if (cancel.list) {
  //   cancel.list.cancel();
  // }

  //cancel.list = httpRequests.cancelToken();

  const xProps = {
    params: pProps
    //cancelToken: cancel.list.token,
  };
  return requestService(xProps, CARTEIRAS_LIST, 3).then(rRes => {
    return pResolve && pResolve(rRes);
  }).catch(rErr => {
    utils.request.tracer(rErr, "Error Service Carteiras List");
    return pReject && pReject(rErr);
  }).finally(() => {
    pFinally && pFinally();
  });
};
export const read = (pCarteiraId, pResolve, pReject, pFinally) => {
  return requestService({}, `${CARTEIRAS_READ}/${pCarteiraId}`, 3).then(rRes => {
    return pResolve && pResolve(rRes);
  }).catch(rErr => {
    utils.request.tracer(rErr, "Error Service Carteiras Read");
    return pReject && pReject(rErr);
  }).finally(() => {
    pFinally && pFinally();
  });
};
export const modify = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: "patch"
  };
  return requestService(xProps, CARTEIRAS_FAV, 3).then(rRes => {
    return pResolve && pResolve(rRes);
  }).catch(rErr => {
    utils.request.tracer(rErr, "Error Service Carteiras Modify");
    return pReject && pReject(rErr);
  }).finally(() => {
    pFinally && pFinally();
  });
};
export const remove = (pCarteiraId, pResolve, pReject, pFinally) => {
  const xProps = {
    data: {
      carteira_id: pCarteiraId
    },
    method: "delete"
  };
  return requestService(xProps, CARTEIRAS_DELETE, 3).then(rRes => {
    return pResolve && pResolve(rRes);
  }).catch(rErr => {
    utils.request.tracer(rErr, "Error Service Carteiras Remove");
    return pReject && pReject(rErr);
  }).finally(() => {
    pFinally && pFinally();
  });
};
export const pl = {
  add: (pProps, pResolve, pReject, pFinally) => {
    const xProps = {
      data: {
        ...pProps
      },
      method: "POST"
    };
    return requestService(xProps, CARTEIRAS_PL_ADD, 3).then(rRes => {
      return pResolve(rRes);
    }).catch(rErr => {
      utils.request.tracer(rErr, "Error Service Carteira PL Add");
      return pReject(rErr);
    }).finally(() => {
      pFinally && pFinally();
    });
  },
  remove: (pProps, pResolve, pReject, pFinally) => {
    const xProps = {
      data: {
        ...pProps
      },
      method: "DELETE"
    };
    return requestService(xProps, CARTEIRAS_PL_REMOVE, 3).then(rRes => {
      return pResolve(rRes);
    }).catch(rErr => {
      utils.request.tracer(rErr, "Error Service Carteira PL Remove");
      return pReject(rErr);
    }).finally(() => {
      pFinally && pFinally();
    });
  },
  list: (pParams, pResolve, pReject, pFinally) => {
    const xProps = {
      params: {
        ...pParams
      }
    };
    return requestService(xProps, CARTEIRAS_PL_LIST, 3).then(rRes => {
      return pResolve(rRes);
    }).catch(rErr => {
      utils.request.tracer(rErr, "Error Service Carteira PL List");
      return pReject(rErr);
    }).finally(() => {
      pFinally && pFinally();
    });
  },
  modify: (pProps, pResolve, pReject, pFinally) => {
    const xProps = {
      data: {
        ...pProps
      },
      method: "PATCH"
    };
    return requestService(xProps, CARTEIRAS_PL_MODIFY, 3).then(rRes => {
      return pResolve(rRes);
    }).catch(rErr => {
      utils.request.tracer(rErr, "Error Service Carteira PL Modify");
      return pReject(rErr);
    }).finally(() => {
      pFinally && pFinally();
    });
  }
};
const entidades = {
  list,
  read,
  modify,
  remove,
  create,
  pl
};
export default entidades;
